module.exports = __webpack_public_path__ + "img/kjjh_gallery5.ac453998.jpg";